"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M40.256 30.045c-.065 0-.142 0-.162-.006a12.551 12.551 0 0 1-9.765-5.68 4.463 4.463 0 0 0-.3-.359 4.463 4.463 0 0 0 .3-.359 12.552 12.552 0 0 1 9.765-5.68c.02 0 .1 0 .162-.006a7.978 7.978 0 1 0-6.133-2.555l-9.1 5.157L9.8 11.94a5.333 5.333 0 0 0-5.065-.1l-3.87 1.916L18.943 24 .865 34.243l3.869 1.919a5.333 5.333 0 0 0 5.065-.1l15.222-8.615 9.1 5.157a8.01 8.01 0 1 0 6.133-2.556zM40.3 5.811A4.2 4.2 0 1 1 35.811 9.7 4.2 4.2 0 0 1 40.3 5.811zm0 36.378a4.2 4.2 0 1 1 3.888-4.49 4.2 4.2 0 0 1-3.888 4.49z" })
);

